// extracted by mini-css-extract-plugin
export var container = "FeaturedVideo-module--container--3be31";
export var content = "FeaturedVideo-module--content--93052";
export var headingWrapper = "FeaturedVideo-module--headingWrapper--6bbb3";
export var playButton = "FeaturedVideo-module--playButton--cb037";
export var poster = "FeaturedVideo-module--poster--8a98c";
export var videoWrapper = "FeaturedVideo-module--videoWrapper--d8b3d";
export var videoWrapperInner = "FeaturedVideo-module--videoWrapperInner--6e1bf";